var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100",attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":"AIChatView"}},[_c('router-view')],1),(_vm.message)?_c('toast',{attrs:{"message":_vm.message},on:{"closed":function($event){_vm.message=''}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }